import { AutoMap } from "@automapper/classes";
import { MaterielEauDTO } from "./materiel-eau.dto";

export class MeasureEauDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    samplingId!: number;
    @AutoMap()
    samplingTime?: string;
    @AutoMap()
    materielEau!: MaterielEauDTO;
    @AutoMap()
    sampleCode?: string;
}